var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-spot"},[_c('div',{staticClass:"project-title"},[_vm._v(_vm._s(_vm.name))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-img"},[_c('img',{attrs:{"src":require("@/assets/leadCockpitImage/project.png"),"alt":""}})])
}]

export { render, staticRenderFns }